import coordinatorRoutes from 'routes/routesByRole/adminRoutes';

export default coordinatorRoutes;
